import { BasicStorageManager } from '@bridebook/toolbox/src/storage-managers';

export const VenueConfirmationStorage = BasicStorageManager<Date>({
  storageKey: 'venue-confirmation-shown',
});
